var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-block" }, [
    _c("h3", [_vm._v("Bump bid")]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "form-row agent-fees" },
        [
          _c("b-form-group", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "container" },
              [
                _vm.modelData && _vm.modelData.ranges
                  ? [
                      _vm._l(_vm.modelData.ranges, function(range, index) {
                        return [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c("div", { staticClass: "col-2 col-sm-2" }, [
                                _vm._v(_vm._s(range.price_min))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-1" }, [
                                _vm._v("-")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-3",
                                  attrs: { state: _vm.rangeFieldState(index) }
                                },
                                [
                                  _vm._v(
                                    "\n                                    ¥\n                                    "
                                  ),
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      placeholder: "max",
                                      step: "1000",
                                      state: _vm.rangeFieldState(index),
                                      id: _vm.getId(
                                        "ranges" + index + "price_max"
                                      )
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onMaxInput(index, $event)
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.modelData.ranges[index].price_max,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.modelData.ranges[index],
                                          "price_max",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "modelData.ranges[index].price_max"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-1" }, [
                                _vm._v("=")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { staticClass: "col-md-3" },
                                [
                                  _vm._v(
                                    "\n                                    ¥\n                                    "
                                  ),
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      placeholder: "bump bid(yen)",
                                      id: _vm.getId("ranges" + index + "fee"),
                                      step: "1000"
                                    },
                                    on: { input: _vm.onInput },
                                    model: {
                                      value: _vm.modelData.ranges[index].fee,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.modelData.ranges[index],
                                          "fee",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "modelData.ranges[index].fee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-1" },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      staticClass: "btn",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeAgentRow(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Remove")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.rangeFieldState(index) === false
                            ? _c(
                                "div",
                                { staticClass: "row align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "alert alert-danger" },
                                    _vm._l(_vm.rangeFieldError(index), function(
                                      err
                                    ) {
                                      return _c("div", [
                                        _vm._v("- " + _vm._s(err))
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "isolated-add-button row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _c(
                        "b-btn",
                        { staticClass: "btn", on: { click: _vm.addAgentRow } },
                        [_vm._v("Add bump")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.modelData
                  ? _c("div", { staticClass: "increase row" }, [
                      _c(
                        "div",
                        {},
                        [
                          _vm._v(
                            "\n                            Increase bid by\n                            "
                          ),
                          _c("b-form-input", {
                            attrs: {
                              type: "number",
                              id: _vm.getId("bump_bid_step_value"),
                              step: "1000"
                            },
                            on: { input: _vm.onInput },
                            model: {
                              value: _vm.modelData.bump_bid_step_value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.modelData,
                                  "bump_bid_step_value",
                                  _vm._n($$v)
                                )
                              },
                              expression: "modelData.bump_bid_step_value"
                            }
                          }),
                          _vm._v("\n                            every "),
                          _c("b-form-input", {
                            attrs: {
                              type: "number",
                              id: _vm.getId("bump_bid_step"),
                              step: "1000"
                            },
                            on: { input: _vm.onInput },
                            model: {
                              value: _vm.modelData.bump_bid_step,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.modelData,
                                  "bump_bid_step",
                                  _vm._n($$v)
                                )
                              },
                              expression: "modelData.bump_bid_step"
                            }
                          }),
                          _vm._v(
                            "\n                            yen for bids over "
                          ),
                          _c("b-form-input", {
                            attrs: {
                              type: "number",
                              id: _vm.getId("bump_bid_step_after"),
                              step: "1000"
                            },
                            on: { input: _vm.onInput },
                            model: {
                              value: _vm.modelData.bump_bid_step_after,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.modelData,
                                  "bump_bid_step_after",
                                  _vm._n($$v)
                                )
                              },
                              expression: "modelData.bump_bid_step_after"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a5b3ef5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5b3ef5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/BumpBids.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0a5b3ef5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/BumpBids.vue
// module chunks = 0